import { CreditUsage } from '@/api_client/types/credit_usages'

export const deserializeCreditUsage = (data): CreditUsage => {
  if (data == null) {
    return null
  }

  return {
    id: data.id,
    user_id: data.user_id,
    credit_record_id: data.credit_record_id,
    audio_id: data.audio_id,
    audio_meta: data.audio_meta,
    type: data.type,
    deleted_audio_json: data.deleted_audio_json,
    used_credits: data.used_credits,
    created_at: data.created_at,
  }
}
